import { useState } from "react";
import { Settings } from "lucide-react";
import Modal from './Modal';
import UserSettingsModal from "./UserSettingsModal";
import { auth } from "../firebase";

function Header() {
  const [showSuscripcionModal, setShowSuscripcionModal] = useState(false);
  const [showUserSettings, setShowUserSettings] = useState(false);

  const handleAddSuscripcion = (data) => {
    setShowSuscripcionModal(false);
  };

  return (
    <>
      <header className="text-black p-4 flex flex-col sm:flex-row justify-between items-start sm:items-center 
        w-full max-w-6xl lg:max-w-7xl xl:max-w-[1200px] 2xl:max-w-[1400px] 
        mx-auto mt-4 rounded-xl shadow px-4 sm:px-6 lg:px-12">
        
        {/* Título */}
        <div className="w-full sm:w-auto">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold">
            Mis Suscripciones
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-gray-500 pt-2">
            Gestiona y controla todos tus gastos recurrentes
          </p>
        </div>

        {/* Botones */}
        <div className="w-full sm:w-auto mt-4 sm:mt-0 flex flex-col sm:flex-row sm:items-center">
          <nav className="flex flex-col sm:flex-row w-full sm:w-auto">
            <button
              className="font-semibold flex items-center bg-gray-100 text-black mb-2 sm:mb-0 sm:mx-2 lg:mx-4 
                duration-300 hover:cursor-pointer rounded-lg p-2 hover:bg-blue-400 hover:text-white justify-center"
              onClick={() => setShowUserSettings(true)}
            >
              <Settings className="w-6 h-6 pr-2" /> Configurar
            </button>

            <button
              className="bg-blue-400 p-2 rounded-lg sm:mx-2 duration-300 text-white font-semibold 
                hover:bg-blue-500 hover:cursor-pointer"
              onClick={() => setShowSuscripcionModal(true)}
            >
              + Añadir Suscripción
            </button>
          </nav>
        </div>
      </header>

      {/* Modal para añadir suscripción */}
      {showSuscripcionModal && (
        <Modal
          onClose={() => setShowSuscripcionModal(false)}
          onSubmit={handleAddSuscripcion}
        />
      )}

      {/* Modal para configuración de usuario */}
      {showUserSettings && auth.currentUser && (
        <UserSettingsModal
          user={auth.currentUser}
          onClose={() => setShowUserSettings(false)}
        />
      )}
    </>
  );
}

export default Header;
